import { axios } from "@cores/axiosWrapper";

export const getAssignableStoragesAPI = (stageId, apiEndpoint, projectId, signal) => {
    const headers = {
        stageId,
    };
    if (projectId) {
        headers.projectId = projectId;
    }

    return axios.get(`${apiEndpoint}/project-storages/assignable-storages`, {
        headers,
        signal,
    });
};

export const getAssignedStoragesAPI = (stageId, apiEndpoint, projectId, params) => {
    const headers = {
        stageId,
    };
    if (projectId) {
        headers.projectId = projectId;
    }

    return axios.get(`${apiEndpoint}/project-storages/assigned-storages`, {
        headers,
        params,
    });
};

export const updateAssignedStoragesAPI = (stageId, apiEndpoint, data) => {
    const { projectId, params } = data;
    const headers = {
        stageId,
    };
    if (projectId) {
        headers.projectId = projectId;
    }

    return axios.post(`${apiEndpoint}/project-storages/assigned-storages/actions`, params, {
        headers,
        customErrorMessage: true,
    });
};
